import { Markdown as BaseMarkdown } from '@customerio/hydra-copilot/react';
import { Text } from '@customerio/pluma-components/react';

export function Markdown({
  children,
  ...rest
}: Omit<React.ComponentProps<typeof Text>, 'children'> & {
  children: string;
}) {
  return (
    <Text flexDirection="column" gap="100" display="flex" overflowWrap="anywhere" color="active" {...rest}>
      <BaseMarkdown>{children}</BaseMarkdown>
    </Text>
  );
}
